export const PREFIX = 'MD-LOOKUP_';

export const SEARCH_REFRESH = PREFIX + 'SEARCH_REFRESH';

export const GET_ALL_PLAN_EXPENSE_SUCCESS = PREFIX + 'GET_ALL_PLAN_EXPENSE_SUCCESS';

export const GET_ALL_ELECTION_TIER_SUCCESS = PREFIX + 'GET_ALL_ELECTION_TIER_SUCCESS';

